import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Fira+Sans&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Roboto');
  @import url('https://fonts.googleapis.com/css?family=Handlee');
  @import url('https://fonts.googleapis.com/css?family=Sacramento');
  @import url('https://fonts.googleapis.com/css?family=Meie+Script');
  @import url('https://fonts.googleapis.com/css?family=Dancing+Script');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    mix-blend-mode: unset;
  }
  *:focus {
    outline: 0;
  }
  html, body, #root {
    height: 100%;
  }
  body {
    -webkit-font-smoothing: antialiased;
  }
  body, input, button {
    font: 14px 'Fira Sans', Helvetica, sans-serif;
  }
  a {
    text-decoration: none;
    color: #333;
  }
  ul {
    list-style: none;
  }
  button {
    cursor: pointer;
  }
  .loading {
    margin: 0 auto;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
